// extracted by mini-css-extract-plugin
export var card = "_i6-5";
export var cardSelected = "_i6-4";
export var image = "_i6-3";
export var modal = "_i6-0";
export var modalContent = "_i6-1";
export var table = "_i6-2";